<div class="sku-groups-shell">

  <!-- TOP BAR -->
  <div class="sku-groups-topbar">
    <div class="sku-groups-title">SKU Grouping</div>
  </div>

  <!-- FILTERS -->
  <div class="sku-groups-filters">

    <fieldset class="rms-fieldset">
      <legend>Group Filter</legend>
      <div class="group-filter">
        <div class="filter-col">
          <rms-select name="Region"
                      label="Region"
                      [(ngModel)]="SelectedRegion"
                      [options]="InventoryData.Regions"
                      labelKey="RegionName"
                      valueKey="RegionId"
                      (selectionChange)="applyFilters()">
          </rms-select>
        </div>

        <div class="filter-col">
          <rms-select name="Country"
                      label="Country"
                      [(ngModel)]="SelectedCountry"
                      [options]="filteredCountries"
                      labelKey="CountryName"
                      valueKey="CountryID"
                      [disabled]="!SelectedRegion"
                      (selectionChange)="applyFilters()">
          </rms-select>
        </div>
        <div class="filter-col">
          <rms-input type="search" name="GroupSearch" label="Search Groups..." [(ngModel)]="GroupSearch" (ngModelChange)="applyFilters()"></rms-input>
        </div>
        <div class="filter-col">
          <button type="button" class="clear-link" (click)="clearFilters()">
            <mat-icon>close</mat-icon>
            Clear Filters
          </button>
        </div>
      </div>
    </fieldset>
    <!-- SKU SEARCH -->
    <fieldset class="rms-fieldset">
      <legend>SKU Filter</legend>
      <div class="group-filter">
        <div class="filter-col search-col">
          <rms-input type="search"
                     name="SkuSearch"
                     label="Search SKU (Name or ID)"
                     [(ngModel)]="SkuSearch"
                     (ngModelChange)="applyFilters()">
          </rms-input>
        </div>
      </div>
    </fieldset>
    <div>
      <button mat-button class="btn-bg-green" (click)="onOpenGroupManagement()">
        <mat-icon>add</mat-icon>
        ADD NEW GROUP
      </button>
    </div>
  </div>

  <!-- BODY -->
  <div class="sku-groups-body">

    <fieldset class="rms-fieldset left-tree-fieldset">
      <legend>Grouping \ SKU Hierarchy</legend>
      <div style="display:flex; flex-direction:column; gap:5px; width: 100%">
        @if(isDraggingGlobal){
        <div class="arrow-container"
             appDragDrop
             (dragover)="startAutoScroll('up')"
             (dragleave)="stopAutoScroll()">
          <mat-icon>arrow_upward</mat-icon>
        </div>
        }
        <div class="group-container" #scrollContainer appDragDrop>
          @for(group of filteredGroups; track group.GroupID; let i = $index){
          <div [class.expanded]="group.expanded" class="parent-container" (dragover)="onDragEnter(group)" (dragleave)="onDragLeave(group)">

            <div class="parent-text" appDragDrop (click)="group.expanded = !group.expanded" (dataDropped)="group.children.length > 0 ? '' : onDropToGroup($event, group)">
              <mat-icon [class.expanded]="group.expanded">chevron_right</mat-icon>

              {{group.GroupName}}

            <div class="edit-btn">
              <button style="color:red"
                      mat-icon-button
                      (click)="onDeleteGroup(group); $event.stopPropagation()">
                <mat-icon>delete</mat-icon>
              </button>
              <button mat-icon-button style="color:green"
                      (click)="onOpenGroupManagement(group); $event.stopPropagation()">
                <mat-icon>edit</mat-icon>
              </button>
            </div>
            </div>
            @if(group.expanded){
            <div class="parent-inner-container">
              @if(group.children){
              @for(child of group.children; track child.GroupID){
              <div class="child-container" [class.expanded]="child.expanded">

                <div class="child-header" appDragDrop (dataDropped)="onDropToGroup($event, child)"
                     (click)="child.expanded = !child.expanded; $event.stopPropagation()">
                  <mat-icon [class.expanded]="child.expanded">chevron_right</mat-icon>
                  {{child.GroupName}}
                <div class="edit-btn">
                  <button style="color:red"
                          mat-icon-button
                          (click)="onDeleteGroup(child); $event.stopPropagation()">
                    <mat-icon>delete</mat-icon>
                  </button>
                  <button style="color:green"
                          mat-icon-button
                          (click)="onOpenGroupManagement(child); $event.stopPropagation()">
                    <mat-icon>edit</mat-icon>
                  </button>

                </div>
                </div>
                @if(child.expanded){
                <div class="child-body">
                  @for(sku of child.skus; track sku.InventoryTypeID){
                  <div class="sku-card"
                       [class.selected]="selectedSkus.has(sku)"
                       [class.multi-drag]="isDraggingGlobal && selectedSkus.has(sku)"
                       (click)="toggleSelection(sku)"
                       appDragDrop
                       [dragData]="getDragPayload(sku)"
                       (dragstart)="onDragStart($event, sku)"
                       (dragend)="onDragEnd()"
                       [disableDrop]="true"
                       [class.non-droppable]="isDraggingGlobal">

                    <span>
                      {{ sku.InventoryTypeID }} - {{ sku.InventoryTypeName }}
                    </span>

                    <button class="icon-btn"
                            (click)="UpdateSkuGrouping(sku, null, true); $event.stopPropagation()">
                      <mat-icon>close</mat-icon>
                    </button>

                  </div>
                  }
                </div>
                }
              </div>
              }
              @empty{
              <h4>No Child Groups</h4>
              }
              }
              @if(group.children.length === 0){
              @for(sku of group.skus; track sku.InventoryTypeID){
              <div class="sku-card"
                   [class.selected]="selectedSkus.has(sku)"
                   [class.multi-drag]="isDraggingGlobal && selectedSkus.has(sku)"
                   (click)="toggleSelection(sku)"
                   appDragDrop
                   [dragData]="getDragPayload(sku)"
                   (dragstart)="onDragStart($event, sku)"
                   (dragend)="onDragEnd()"
                   [disableDrop]="true"
                   [class.non-droppable]="isDraggingGlobal">

                <span>{{ sku.InventoryTypeID }} - {{ sku.InventoryTypeName }}</span>

                <button class="icon-btn"
                        (click)="UpdateSkuGrouping(sku, null, true); $event.stopPropagation()">
                  <mat-icon>close</mat-icon>
                </button>

              </div>
              }
              }
            </div>
            }
          </div>
          }
        </div>
        @if(isDraggingGlobal){
        <div class="arrow-container"
             (dragover)="startAutoScroll('down')"
             (dragleave)="stopAutoScroll()"
             appDragDrop>
          <mat-icon>arrow_downward</mat-icon>
        </div>
        }
      </div>
    </fieldset>

    <!-- RIGHT SIDE -->
    <section class="sku-group-container">

      <!-- UNGROUPED -->
      <fieldset appDragDrop (dataDropped)="onDropToUngrouped($event)" class="rms-fieldset remove-group" style="height:60%">
        <legend>Ungrouped SKUs</legend>
        <div class="sku-container">
          @for(sku of filteredUngrouped; track sku.InventoryTypeID){
          <div class="sku-card"
               [class.selected]="selectedSkus.has(sku)"
               [class.multi-drag]="isDraggingGlobal && selectedSkus.has(sku)"
               (click)="toggleSelection(sku)"
               appDragDrop
               [dragData]="getDragPayload(sku)"
               (dragstart)="onDragStart($event, sku)"
               (dragend)="onDragEnd()"
               [disableDrop]="true"
               [class.non-droppable]="isDraggingGlobal">

            <span>{{ sku.InventoryTypeID }} - {{ sku.InventoryTypeName }}</span>
            <button class="icon-btn" style="color:red"
                    (click)="onArchive(sku, true); $event.stopPropagation()"
                    title="Archive SKU">
              <mat-icon>archive</mat-icon>
            </button>
          </div>
          }

        </div>

      </fieldset>

      <!-- ARCHIVED -->
      <fieldset class="rms-fieldset" style="height:33%">
        <legend>Archived SKUs</legend>
        <div class="sku-container">
          @for(sku of filteredArchived; track sku.InventoryTypeID){
          <div class="sku-card"
               [class.selected]="selectedSkus.has(sku)"
               [class.multi-drag]="isDraggingGlobal && selectedSkus.has(sku)"
               (click)="toggleSelection(sku)"
               appDragDrop
               [dragData]="getDragPayload(sku)"
               (dragstart)="onDragStart($event, sku)"
               (dragend)="onDragEnd()"
               [disableDrop]="true"
               [class.non-droppable]="isDraggingGlobal">

            <span>{{ sku.InventoryTypeID }} - {{ sku.InventoryTypeName }}</span>
            <button class="icon-btn" style="color:red"
                    (click)="onArchive(sku, false); $event.stopPropagation()"
                    title="Unarchive SKU">
              <mat-icon>unarchive</mat-icon>
            </button>
          </div>
          }
        </div>
      </fieldset>

    </section>

  </div>
</div>
